import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import { Panel, PanelBody } from "./../../components/panel/panel.jsx";
import TableForContacts from './TableForContacts.jsx'
import { myContactsActions, sendPhotosActions } from "../../_store";
import { showAlert } from "../../components/common/showAlert.js";
import ConfirmationModal from "../../components/common/UI/Inputs/NotificationModal/BootstrapModalPopup.jsx";
import { ReactNotifications } from "react-notifications-component";
import NotificationService from "../../../src/ui/ui-modal-notification.js";
import inmateTransferFundSchema from "../../validation/inmateTransferFundSchema.js";
import accepted from "../../assets/images/accepted.png";
import cancelled from "../../assets/images/cancelled.png";
import exit from "../../assets/images/exit.png";
import pending from "../../assets/images/pending.png";
import rejected from "../../assets/images/rejected.png";
import ReleasedAndCanceled from "../../assets/images/ReleasedAndCanceled.png";
import blocked from "../../assets/images/blocked.png";
import useDraft from '../../components/common/autoSaveDraftMsg/useDraft';
import Table from '../../components/common/Table.jsx'
import useFullPageLoader from "../../hooks/useFullPageLoader.jsx";
import translations from '../../config/TranslateFile.jsx'
import { EventLog } from "../../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import { getStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";

function MyContacts() {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showblockedModal, setshowblockedModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [paymentMsg, setPaymentMsg] = useState("");
  const [isPaymentMsg, setIsPaymentMsg] = useState(false);
  const [previousPath, setPreviousPath] = useState("");
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [isActionDisabled, setIsActionDisabled] = useState(false);
  const currentLang = translations();
  const [Inmate, setInmate] = useState({
    InmateLastName: "",
    CreditBalance: "",
    ToInmate: "",
    TransferAmount: "",
    InmateID: 0,
  });

  let navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // Auto Draft save
  const { setIsSaveDraftModified } = useDraft();
  useEffect(() => {
    const savedDraft = getStoredValue('draft');
    if (savedDraft != null) {
      setIsSaveDraftModified(true);
    }
  }, [setIsSaveDraftModified]);

  // State used for Pulic User make Cancel request and accept request
  const [insertUpdateInmateConnection, setInsertUpdateInmateConnection] =
    useState({
      PUIConnectionID: 0,
      UserID: 0,
      InmatesId: 0,
      FacilityID: 0,
      RequestChangeUser: "PublicUser",
      ToConnectionStatusID: 3,
      Action: 0,
      IsSALoginAsPU: 0,
      InmateResidentID: "string",
      RelationShip: "string",
      InmateInvitePublicUserID: 0,
    });

  const {
    PublicMyContactsDisplayNew,
    saveFundTransferResponse,
    CheckInmateConnectionStatus,
    InsertUpdateInmateStatus,
  } = useSelector((state) => state.myContacts);
  const MsgPhotoStatusResponse = useSelector((state) => state.sendPhotos.CheckingMsgPhotoStatusResponse);
  //   const PublicUser = useSelector((x) => x.auth.user);
  const [isOpenModal, setOpenModal] = useState(false);
  const [isPaymentModal, setPaymentModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [transformedData, setTransformedData] = useState([]);
  const [InmateDetail, setInmateDetail] = useState({
    InmateLastName: "",
    InmateName: "",
    CreditBalance: "",
    ToInmateID: 0,
    ToInmateOption: null,
    TransferAmount: "",
    ToInmateList: "",
    SelectedInmateOption: null,
  });
  const UserId = getStoredValue("userID");

  const columns = [
    {
      name: currentLang?.InmateID,
      selector: (row) => row.InmateResidentId,
      sortable: true,
    },
    {
      name: currentLang?.LastName,
      selector: (row) => row.InmateLastName,
      sortable: true,
    },
    {
      name: currentLang?.FirstName,
      selector: (row) => row.InmateFirstName,
      sortable: true,
    },
    {
      name: currentLang?.FacilityName,
      selector: (row) => row.FacilityName,
      sortable: true,
    },
    {
      name: currentLang?.Credits,
      selector: (row) =>
        row.CreditBalance !== 0
          ? row.CreditBalance.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
          : "0.00",
      sortable: true,
    },
    {
      name: currentLang?.Status,
      sortable: true,
      accessor: "ConnectionStatus",
      cell: (row) => {
        let imageSrc = "";
        let tooltipMsg = "";
        let className = "";
        switch (row.ConnectionStatus) {
          case "Request Accepted":
            imageSrc = accepted;
            tooltipMsg = currentLang?.tooltip?.Accepted;
            className = 'status-accepted';
            break;
          case "Inmate Released":
            imageSrc = exit;
            tooltipMsg = currentLang?.tooltip?.Inmate_Released;
            className = 'status-released'
            break;
          case "Request Blocked":
            imageSrc = blocked;
            tooltipMsg = currentLang?.tooltip?.Blocked;
            className = 'status-blocked';
            break;
          case "Request Rejected":
            imageSrc = rejected;
            tooltipMsg = currentLang?.tooltip?.Rejected;
            className = 'status-rejected'
            break;
          case "Request Canceled":
            imageSrc = cancelled;
            tooltipMsg = currentLang?.tooltip?.Canceled;
            className = 'status-cancelled'
            break;
          case "Released & Canceled":
            imageSrc = ReleasedAndCanceled;
            tooltipMsg = currentLang?.tooltip?.Released_Canceled;
            className = 'status-released-cancelled'
            break;
          case "Pending Approval":
            imageSrc = pending;
            tooltipMsg = currentLang?.tooltip?.Pending_Approval;
            className = 'status-pending'
            break;
          default:
            imageSrc = "";
            tooltipMsg = "";
            className = ''
        }

        return (
          <>
            <div className={className}
            >
              {tooltipMsg}
            </div>
          </>
        );
      },
    },
    {
      name: currentLang?.Action,
      sortable: true,
      accessor: "InmateID",

      // row :row.InmateID,
      cell: (row) => {
        return (
          <>
            <div className="d-flex">
              <div
                className="btn btn-primary shadow btn-xs sharp me-1 fixed-size-btn"
                title={currentLang?.PurchaseHistory}
                onClick={() => handleChanges(row)}
              >
                <i className="fas fa-history"></i>
              </div>

              {(row.InmateStatus === 1 || (row.InmateStatus === 0 && row.ConnectionStatusID === 3) || row.CreditBalance !== "0.00") && row.CreditBalance !== "0.00" && (
                <div
                  className="btn btn-success shadow btn-xs sharp me-1 fixed-size-btn"
                  title={currentLang?.Mycontacts?.Transfer_Funds}
                  data-bs-toggle="modal"
                  data-bs-target="#modalDialog1"
                  onClick={() => TransferFundsHandleChanges(row)}
                >
                  <i class="fa-solid fa-money-bill-transfer"></i>
                </div>
              )}
              {row.ConnectionStatusID === 3 &&
                row.InmateStatus === 1 && ( // Ensure the div is not shown if ConnectionStatusID is 3
                  <div
                    className={`btn shadow btn-xs sharp me-1 fixed-size-btn button-success`}
                    title={currentLang?.Mycontacts?.Accept_Request}
                    onClick={() => InmateConnectionStatus(row)}>
                    <i className={`fa fa-check`}></i>
                  </div>
                )}

              {((row.ConnectionStatusID === 2 &&
                row.InmateStatus === 1) || (row.InmateStatus !== 1 && (row.InmateStatus === 0 && row.ConnectionStatusID !== 3))) && ( // Ensure the div is not shown if ConnectionStatusID is 3
                  <div
                    className={`btn shadow btn-xs sharp me-1 fixed-size-btn btn-warning`}
                    title={currentLang?.Mycontacts?.Cancel_Request}
                    onClick={() => InmateConnectionStatus(row)}>
                    <i className={`fa fa-times`}></i>
                  </div>
                )}

              {(row.InmateStatus === 1 && row.ConnectionStatusID === 2 && row.IsAllowToPuchaseCredit === 1) && (
                <div
                  className="btn btn-danger shadow btn-xs sharp me-1 fixed-size-btn "
                  title={currentLang?.Mycontacts?.Purchase_Credit}
                  onClick={() => PurchaseCreditshandlechanges(row)}
                >
                  <i class="fa-solid fa-dollar-sign"></i>
                </div>)}
            </div>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (PublicMyContactsDisplayNew) {
      hideLoader();
      // Transform the data by picking the necessary fields and adding status logic
      const newData = PublicMyContactsDisplayNew.map((row) => {
        let tooltipMsg = "";

        switch (row.ConnectionStatus) {
          case "Request Accepted":
            tooltipMsg = currentLang?.tooltip?.Accepted;
            break;
          case "Inmate Released":
            tooltipMsg = currentLang?.tooltip?.Inmate_Released;
            break;
          case "Request Blocked":
            tooltipMsg = currentLang?.tooltip?.Blocked;
            break;
          case "Request Rejected":
            tooltipMsg = currentLang?.tooltip?.Rejected;
            break;
          case "Request Canceled":
            tooltipMsg = currentLang?.tooltip?.Canceled;
            break;
          case "Released & Canceled":
            tooltipMsg = currentLang?.tooltip?.Released_Canceled;
            break;
          case "Pending Approval":
            tooltipMsg = currentLang?.tooltip?.Pending_Approval;
            break;
          default:
            tooltipMsg = "";
        }
        return {
          InmateResidentId: row.InmateResidentId,
          InmateLastName: row.InmateLastName,
          InmateFirstName: row.InmateFirstName,
          FacilityName: row.FacilityName,
          CreditBalance: row.CreditBalance !== 0 && row.CreditBalance !== undefined
            ? row.CreditBalance.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
            : "0.00",
          tooltipMsg: tooltipMsg,
          ConnectionStatus: row.ConnectionStatus,
          ConnectionStatusID: row.ConnectionStatusID, // Make sure this field is included
          InmateStatus: row.InmateStatus,
          IsAllowToPuchaseCredit: row.IsAllowToPuchaseCredit,
          PUIConnectionID: row.PUIConnectionID,
          FacilityMessageCost: row.FacilityMessageCost,
          InmateID: row.InmateID,
          PublicUserID: row.PublicUserID,
          facilityID: row.facilityID,
          RelationShip: row.RelationShip,
          InmateName: row.InmateName
        };
      });

      // Set the transformed data to state
      setTransformedData(newData);
    }
  }, [PublicMyContactsDisplayNew]);

  const handleChanges = (row) => {
    setStoredValue("puiConnectionID", row.PUIConnectionID);
    setStoredValue("PurchaseHistoryInmateName", row.InmateName)
    setStoredValue("PurchaseHistoryInmateID", row.InmateID);
    navigate("/public/PurchaseHistory");
    storeCurrentRoute("/public/PurchaseHistory");
  };

  // Click cancel my account action button click means
  const InmateConnectionStatus = (row) => {
    if (isActionDisabled) return

    setIsActionDisabled(true);

    let inmatesID = row?.InmateID;
    let userID = row?.PublicUserID;
    let rowData = row;
    setInsertUpdateInmateConnection((prevState) => ({
      ...prevState, // Keep previous state values if any exist
      PUIConnectionID: rowData.PUIConnectionID,
      UserID: rowData.PublicUserID,
      InmatesId: rowData.InmateID,
      FacilityID: rowData.facilityID,
      // RequestChangeUser: rowData.RequestChangeUser,
      ToConnectionStatusID: rowData?.ConnectionStatusID === 2 ? 3 : 2, // 3 - Cancel Request & 2- Accept Request
      Action: 0,
      IsSALoginAsPU: 0,
      InmateResidentID: rowData.InmateResidentId,
      RelationShip: rowData.RelationShip,
      InmateInvitePublicUserID: rowData.PublicUserID,
    }));
    if (row.ConnectionStatusID === 3) {
      const infoMessage = "Accept Inmate Connection ( Inmate ID - " + row?.InmateID || 0 + " )";
      const redirectURL = `---`;
      const Response = `---`;
      const Status = `---`;
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
    }
    else if (row.ConnectionStatusID === 2) {
      const infoMessage = "My Contacts - Click Cancel Connection Request button - Confirmation popup";
      const redirectURL = "Shows YES or NO popup to Cancel Inmate Connection ( Inmate ID - " + row?.InmateID || 0 + " )";
      const Response = `---`;
      const Status = `---`;
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
    }
    dispatch(
      myContactsActions.LoadPublicInmateConnectionDet({
        userID,
        inmatesID,
      })
    ).then((x) => {
      //  setIsActionDisabled(false);
      var result = x.payload[0].ConnectionStatusID
      if (result != null) {
        switch (result) {
          case 5:
          case 4:
            setshowblockedModal(true); setIsActionDisabled(false);
            break;
          default:
            if (row.ConnectionStatusID === 2 || result == 2) {
              // Cancel Request Means else accept request
              setShowCancelModal(true);
            }
            else if (row.ConnectionStatusID === 3 || result == 3) {
              handleConfirmCancel(row);
            }
        }
      }
    })
  };

  // Load MyContact List Grid
  useEffect(() => {
    loadContacts();
  }, []);

  // If user click on cancel my account (yes) deactivation service calling
  const handleConfirmCancel = (row) => {
    if (row?.PublicUserID) {
      var data = {
        PUIConnectionID: row.PUIConnectionID,
        UserID: row.PublicUserID,
        InmatesId: row.InmateID,
        FacilityID: row.facilityID,
        ToConnectionStatusID: row?.ConnectionStatusID === 2 ? 3 : 2, // 3 - Cancel Request & 2- Accept Request
        Action: 0,
        IsSALoginAsPU: 0,
        InmateResidentID: row.InmateResidentId,
        RelationShip: row.RelationShip,
        InmateInvitePublicUserID: row.PublicUserID,
        RequestChangeUser: "PublicUser"
      };
    }
    else {
      var params = row ? { ...insertUpdateInmateConnection, ToConnectionStatusID: row?.ConnectionStatusID == 3 ? 2 : 3 } : insertUpdateInmateConnection;
    }
    try {
      dispatch(
        myContactsActions.UpdateInmateConnection(row?.PublicUserID ? data : params)
      ).then((x) => {
        var result = x.payload;
        if (result != null) {
          switch (result) {
            case 1:
              let message =
                params?.ToConnectionStatusID === 3
                  ? currentLang?.MyContactsPopContent?.Request_Cancelled_Success
                  : currentLang?.MyContactsPopContent?.Request_Accept_Success;
              NotificationService({
                title: currentLang?.Success,
                message: message,
                type: "success", // can be 'success', 'danger', 'info', 'warning'
              });

              // Reload the grid data after success
              loadContacts();
              dispatch(myContactsActions.clearInmateConnectionStatus());
              break;
            case -4:
            case -5:
              NotificationService({
                title: currentLang?.MyContactsPopContent?.Connection_request_Rejected,
                message: currentLang?.MyContactsPopContent?.Connection_request_Rejected_Admin,
                type: "warning", // can be 'success', 'danger', 'info', 'warning'
              });
              dispatch(myContactsActions.clearInmateConnectionStatus());
              break;
            default:
              setShowCancelModal(false); setshowblockedModal(false)
          }
          setIsActionDisabled(false);
        }
      })
    }
    catch {
      setIsActionDisabled(false);
    }
    const infoMessage = "Cancelled Inmate Connection ( Inmate ID - " + params?.InmatesId || 0 + " )";
    const redirectURL = `---`;
    const Response = `---`;
    const Status = `---`;
    EventLog(dispatch, infoMessage, redirectURL, Response, Status);
    setShowCancelModal(false); setshowblockedModal(false)
  };

  // Cancel MyAccount Confirmation Alert No button click event
  const handleNoClick = () => {
    setIsActionDisabled(false);
    setShowCancelModal(false);
    dispatch(myContactsActions.clearInmateConnectionStatus());
    const infoMessage = "My Contacts - Clicked NO Option from Cancel Connection Request - confirmation Popup";
    const redirectURL = `---`;
    const Response = `---`;
    const Status = "Hided confirmation popup";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status);
  };


  // Purchase Credit status checking
  useEffect(() => {
    if (MsgPhotoStatusResponse) {
      const { Result, Notes } = MsgPhotoStatusResponse;
      switch (Result) {
        case -7:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Connection_Blocked)
          setIsPaymentMsg(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -8:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.No_longer_connected)
          setIsPaymentMsg(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -6:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Contact)
          setIsPaymentMsg(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -4:
          setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Facility)
          setIsPaymentMsg(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -3:
          setPaymentMsg(Notes);
          setIsPaymentMsg(true);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        default:
          if (Result === 0) {
            setStoredValue("InmateID", Inmate.InmateID)
            navigate("/public/PurchaseCredits", { state: { previousPath: location.pathname } });
            storeCurrentRoute("/public/PurchaseCredits", { state: { previousPath: location.pathname } });
            dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());

          }
          break;
      }
    }
  }, [MsgPhotoStatusResponse]);

  const PurchaseCreditshandlechanges = (row) => {
    dispatch(sendPhotosActions.CheckingMsgPhotoStatus({ addFormData: { UserID: row.PublicUserID, InmateID: row.InmateID } }))
    const infoMessage = "Redirected into My Contacts Page to Purchase Credit ( Inmate ID - " + row.InmateID || 0 + " )"
    const redirectURL = "---";
    const Response = `---`;
    const Status = ` Redirected into PublicPurchaseCredits public/PurchaseHistory`;
    EventLog(dispatch, infoMessage, redirectURL, Response, Status);
    setInmate((prev) => ({
      ...prev,
      InmateID: row.InmateID
    }))
  };

  const TransferFundsHandleChanges = (row) => {
    dispatch(
      myContactsActions.LoadPublicMyContactsDisplay({
        userID: UserId,
        inmatesID: 0,
        InmateLoadPurpose: "PurchaseCredit",
        ActiveStatus: 0,
        SortField: "InmateName asc",
      })
    ).then((response) => {
      setAddFormData((prevData) => ({
        ...prevData,
        inmatesId: row?.InmateID, // Update this to the new value you want to set
      }));
      setErrorMessage({});

      const infoMessage = "Redirect into Transfer fund Panel ( Inmate ID - " + row.InmateID || 0 + " )"
      const redirectURL = "---";
      const Response = JSON.stringify(response?.payload);
      const Status = " Inmates Count - " + response?.payload?.length || 0;
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);

      const inmateData = response.payload;

      const filteredInmates = inmateData
        ?.filter((inmate) => inmate.InmateID !== row.InmateID && inmate.ConnectionStatus === "Request Accepted" && inmate.ConnectionStatusID === 2 && inmate.Blocked !== 1)
        .map((inmate) => ({
          label:
            inmate.InmateLastName +
            " " +
            inmate.InmateFirstName +
            " - " +
            inmate.FacilityName,
          value: inmate.InmateID,
        })); // Map to create label-value pairs

      const InmateRowDetails = {
        InmateLastName: row.InmateLastName,
        InmateName: row.InmateName,
        CreditBalance: row.CreditBalance,
        TransferAmount: row.CreditBalance,
        ToInmateList: filteredInmates,
        ToInmateID: null,
        SelectedInmateOption: null,
      };
      setInmateDetail(InmateRowDetails);
      setPaymentModal(true);
      const backdrop = document.createElement("div");
      backdrop.classList.add("modal-backdrop", "fade", "show");
      document.body.appendChild(backdrop);
      setSubmitted(true);
    })
  };

  const loadContacts = (
    userId = UserId,
    inmatesId = 0,
    inmateLoadPurpose = "All",
    activeStatus = 0,
    sortField = "InmateName asc"
  ) => {
    showLoader();
    dispatch(
      myContactsActions.PublicMyContactsDisplayNew({
        userId,
        inmatesId,
        inmateLoadPurpose,
        activeStatus,
        sortField,
      })
    ).then((response) => {
      const infoMessage = "Bind My Contact list";
      const redirectURL = `---`;
      const Response = JSON.stringify(response?.payload);
      const Status = "My contact list count - " + response?.payload?.length || 0
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
    });
  };

  const handleBlur = () => {
    if (InmateDetail.TransferAmount !== "") {
      const formattedValue = parseFloat(InmateDetail.TransferAmount.replace(/,/g, "")).toFixed(2);
      setInmateDetail((prevInmateDetail) => ({
        ...prevInmateDetail,
        TransferAmount: formattedValue, // Format the value to 2 decimal places
      }));
    }
  };


  // Validation for Tranfer Amount Field in Transfer Fund popup
  const handleChange1 = (event) => {
    event.preventDefault();
    const { name, value } = event.target;

    setInmateDetail((prevInmateDetail) => ({
      ...prevInmateDetail,
      [name]: value.trim() || "", // Allow empty string as valid input
    }));

    let sanitizedValue = value.trim().replace(/[^0-9.]/g, ""); // Remove characters that aren't numbers or dots

    const dotCount = sanitizedValue.split(".").length - 1;

    if (dotCount > 1) {
      sanitizedValue = sanitizedValue.slice(0, sanitizedValue.lastIndexOf("."));
    }
    if (sanitizedValue.startsWith(".")) {
      sanitizedValue = "0" + sanitizedValue; // Add a 0 before the dot if the input starts with a dot
    }
    setInmateDetail((prevInmateDetail) => ({
      ...prevInmateDetail,
      [name]: sanitizedValue,
    }));

    const numericValue = sanitizedValue !== "" ? parseFloat(sanitizedValue) : "";

    if (name === "TransferAmount") {
      if (numericValue === "") {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: currentLang?.MyContactsPopContent?.Please_enter_transfer_amount,
        }));
        document.querySelector(`input[name="${[name]}"]`)?.classList.add("input-error");
        return;
      }
      // Ensure the TransferAmount is a valid number and greater than 0
      if (isNaN(numericValue) || numericValue <= 0) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: currentLang?.MyContactsPopContent?.Transfer_Amount_Valid,
        }));
        document.querySelector(`input[name="${[name]}"]`)?.classList.add("input-error");
        return;
      }

      // Check if the TransferAmount is greater than CreditBalance
      const creditBalance = parseFloat(InmateDetail.CreditBalance.replace(/,/g, "")); // Ensure it's a number
      if (isNaN(creditBalance)) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: currentLang?.MyContactsPopContent?.Balance_Not_Valid,
        }));
        document.querySelector(`input[name="${[name]}"]`)?.classList.add("input-error");
        return;
      }

      if (numericValue > creditBalance) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: `${currentLang.MyContactsPopContent?.Transfer_Amount_Cannot_Exceed} $${creditBalance.toFixed(2)}`,
        }));
        document.querySelector(`input[name="${[name]}"]`)?.classList.add("input-error");
        return;
      }

      // If all validation checks pass, clear any previous error
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "",
      }));
      document.querySelector(`input[name="${[name]}"]`)?.classList.remove("input-error");
    }
  };


  const [addFormData, setAddFormData] = useState({
    userID: UserId,
    inmatesId: 0,
    toInmatesId: 0,
    purcharseAmount: 0,
    createdBy: 0,
  });

  // Submit data function
  const handleSubmit = (e) => {
    e?.preventDefault();
    setErrorMessage({}); // Clear any previous error messages

    // Remove the "input-error" class from any previously highlighted inputs
    if (document?.getElementsByClassName("input-error").length !== 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    // Manual validation for InmateDetail
    const errors = {};

    // Validate ToInmateID
    if (!InmateDetail.ToInmateID?.value) {
      errors.ToInmateID = currentLang?.ValidationSchema?.Please_Choose_Inmate;
      document.querySelector(`input[name="ToInmateID"]`)?.classList.add("input-error");
    }

    // Validate TransferAmount
    const transferAmount = InmateDetail.TransferAmount !== "" ? parseFloat(InmateDetail.TransferAmount.replace(/,/g, "")) : "";
    if (transferAmount === "") {
      errors.TransferAmount = currentLang?.MyContactsPopContent?.Please_enter_transfer_amount;
      document.querySelector(`input[name="TransferAmount"]`)?.classList.add("input-error");
    }
    else if (isNaN(transferAmount) || transferAmount <= 0) {
      errors.TransferAmount = currentLang?.MyContactsPopContent?.Transfer_Amount_Valid;
      document.querySelector(`input[name="TransferAmount"]`)?.classList.add("input-error");
    } else {
      // Ensure CreditBalance is a number before calling .toFixed
      const creditBalance = parseFloat(InmateDetail.CreditBalance.replace(/,/g, ""));

      if (isNaN(creditBalance)) {
        errors.TransferAmount = currentLang?.MyContactsPopContent?.Balance_Not_Valid;
        document.querySelector(`input[name="TransferAmount"]`)?.classList.add("input-error");
      } else if (transferAmount > creditBalance) {
        errors.TransferAmount = `${currentLang?.MyContactsPopContent?.Transfer_Amount_Cannot_Exceed} $${creditBalance.toFixed(2)}`;
        document.querySelector(`input[name="TransferAmount"]`)?.classList.add("input-error");
      }
    }

    // If there are validation errors, set the error message state and return
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      return;
    }
    dispatch(
      myContactsActions.LoadPublicMyContactsDisplay({
        userID: UserId,
        inmatesID: InmateDetail?.ToInmateID?.value,
        InmateLoadPurpose: "All",
        ActiveStatus: 0,
        SortField: "InmateName asc",
      })
    ).then((response) => {
      if (response?.meta?.requestStatus === "fulfilled") {
        let data = response?.payload;
        if (data[0]?.IsPurchaseDisabled === 0) {
          // Prepare data for saving
          const newFormData = {
            userID: UserId,
            inmatesId: addFormData?.inmatesId,
            toInmatesId: InmateDetail?.ToInmateID?.value,
            purcharseAmount: InmateDetail?.TransferAmount,
            createdBy: 0,
          };
          // Dispatch the action to save the fund transfer
          dispatch(myContactsActions.saveFundTransfer(newFormData)).then((x) => {
            handleResponse(x?.payload);
          })
          const infoMessage = "From Inmate - " + addFormData?.inmatesId + " Fund Transfered to Inmate - " + InmateDetail?.ToInmateID?.value;
          const redirectURL = "---";
          const Response = "---";
          const Status = "---";
          EventLog(dispatch, infoMessage, redirectURL, Response, Status);
          setErrorMessage({});
          setPaymentModal(false);
          closeModal();
        }
        else {
          setErrorMessage((prev) => ({
            ...prev,
            TransferAmount: "Inmate transactions disabled at this facility."
          }));
        }
      }
    })
  };

  // Transfer Fund - popup close function
  const closeModal = () => {

    // Manually remove the modal's backdrop if it's still present
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      backdrop.remove(); // Remove the backdrop
    }
    // To remove the backdrop
    const existingBackdrop = document.querySelector(".modal-backdrop");
    if (existingBackdrop) {
      existingBackdrop.remove(); // Removes the backdrop element
    }
    // Also make sure the body class is cleaned up
    document.body.classList.remove("modal-open");
    document.body.style = "";
    setErrorMessage({});
    setPaymentModal(false);
  };

  const handleResponse = (saveFundTransferResponse) => {
    if (saveFundTransferResponse === 1) {
      NotificationService({
        title: currentLang?.Success,
        message: currentLang?.MyContactsPopContent?.Fund_Transfer_Success,
        type: "success", // can be 'success', 'danger', 'info', 'warning'
      });
      closeModal();
    } else if (saveFundTransferResponse === -2) {
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.MyContactsPopContent?.Doesnt_have_required_balance,
        type: "warning", // can be 'success', 'danger', 'info', 'warning'
      });
    } else if (saveFundTransferResponse === -3) {
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.MyContactsPopContent?.User_Not_Active,
        type: "warning", // can be 'success', 'danger', 'info', 'warning'
      });
    } else if (saveFundTransferResponse === -4) {
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.MyContactsPopContent?.Purchase_Disabled,
        type: "warning", // can be 'success', 'danger', 'info', 'warning'
      });
    } else if (saveFundTransferResponse === -1) {
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.InboxPopContent?.Something_went_wrong,
        type: "warning", // can be 'success', 'danger', 'info', 'warning'
      });
    } else if (saveFundTransferResponse === -6) {
      NotificationService({
        title: currentLang?.Message,
        message: currentLang?.MyContactsPopContent?.Contact_Restricted,
        type: "warning", // can be 'success', 'danger', 'info', 'warning'
      });
    }
    loadContacts();
    dispatch(myContactsActions.clearInmateConnectionStatus());
  }

  const FundTransferCancelClick = () => {
    closeModal();
    const InmateRowDetails = {
      InmateLastName: "",
      InmateName: "",
      CreditBalance: "",
      ToInmateID: null,
      TransferAmount: "",
      ToInmateList: [],
      SelectedInmateOption: null,
    };
    setInmateDetail(InmateRowDetails);
    setErrorMessage({});
    setPaymentModal(false);
    const infoMessage = "Back to My contacts Main grid Page From Transfer fund Panel";
    const redirectURL = "public/Mycontacts";
    const Response = "---";
    const Status = "Redirected into " + "public/Mycontacts" + "URL";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status);
  };

  const handlePaymentMsg = () => {
    setIsPaymentMsg(false);
  };


  return (
    <>
      <ReactNotifications />
      <div className="">
        {/* <div className="card shadow-lg mb-3">
          <div className="card-header">
            <h5 className="find-inmate-head mb-0">
              <i className="fa fa-address-book"></i>&nbsp;My Contacts
            </h5>
          </div>
        </div> */}
        <div>
          <div className="header-title">
            <h5>
              {/* <i className="fa fa-address-book me-2"></i> */}

              {currentLang?.MyContacts}
            </h5>
          </div>
        </div>
        <div className="h-100 d-flex justify-content-center align-items-center">
          <div className="card w-100 border-radius-all shadow-sm mb-5">
            <div className="card-body">
              <Panel>
                <PanelBody>
                  <div className="card-body">
                    <TableForContacts
                      title="My Contacts"
                      columns={columns || []}
                      data={transformedData}  // Pass the transformed data to the Table
                      showSearch={true}
                      rowsPerPage={10}
                    />
                  </div>
                </PanelBody>
              </Panel>
              {/* ------- Popup for Cancel My Account Popup -------------- */}
              <ConfirmationModal
                show={showCancelModal}
                onHide={handleNoClick}
                onConfirm={handleConfirmCancel}
                title={currentLang?.Message}
                message={currentLang?.MyContactsPopContent?.Cancel_Confirmation}
                closeButton={false}
                onconfirmname={currentLang?.buttons?.Yes}
                oncancelname={currentLang?.buttons?.No}
              />
              {/* Connection Blocked Popup */}
              <ConfirmationModal
                show={showblockedModal}
                onHide={handleNoClick}
                showCancelButton={false}
                onConfirm={() => { setshowblockedModal(false); setIsActionDisabled(false); }}
                title={currentLang?.Message}
                message={currentLang?.MyContactsPopContent?.Connection_Blocked_ByAdmin}
                closeButton={false}
                onconfirmname={currentLang?.buttons?.OK}
              //oncancelname={currentLang?.buttons?.No}
              />
              {/* ---------- Popup for Fund Transfer--------------------- */}
              <div
                className={`modal fade ${isPaymentModal ? "show d-block" : ""}`}
                id="modalDialog1"
                data-bs-backdrop="static"
                tabIndex="-1"
                style={
                  isPaymentModal ? { display: "block" } : { display: "none" }
                }
                aria-labelledby="modalDialog1"
              // aria-hidden={!isPaymentModal}
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title">{currentLang?.Mycontacts?.Fund_Transfer}</h4>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        onClick={() => closeModal()}
                      ></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                      <div className="modal-body">
                        <div className="row mb-3">
                          <label className="form-label col-form-label col-md-4 font-size-14">
                            {currentLang?.Mycontacts?.From_Inmate}
                          </label>
                          <div className="col-md-8">
                            <input
                              type="text"
                              className="form-control"
                              value={InmateDetail.InmateName}
                              name="InmateLastName"
                              placeholder="Inmate Name"
                              disabled
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <label className="form-label col-form-label col-md-4 font-size-14">
                            {currentLang?.Mycontacts?.Credit_Balance} ($)
                          </label>
                          <div className="col-md-8">
                            <input
                              type="text"
                              className="form-control"
                              value={parseFloat(InmateDetail.CreditBalance.replace(/,/g, "")).toFixed(2)}
                              placeholder="Enter Credit Balance"
                              disabled
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <label className="form-label col-form-label col-md-4 font-size-14">
                            {currentLang?.Mycontacts?.To_Inmate}
                          </label>
                          <div className="col-md-8">
                            <Select
                              className="font-size-14"
                              name="ToInmateID"
                              value={InmateDetail.ToInmateID}
                              options={InmateDetail.ToInmateList}
                              placeholder={currentLang?.PurchaseCreditsPage?.Select_Inmate}
                              onChange={(selectedOption) => {
                                setInmateDetail((prev) => ({
                                  ...prev,
                                  ToInmateID: selectedOption,
                                }));
                                setErrorMessage((prev) => ({
                                  ...prev,
                                  ToInmateID: "", // Clear validation error on selection
                                }));
                              }}
                              // Custom styles for error handling
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: errorMessage.ToInmateID
                                    ? "red"
                                    : baseStyles.borderColor,
                                  "&:hover": {
                                    borderColor: errorMessage.ToInmateID
                                      ? "red"
                                      : baseStyles["&:hover"].borderColor,
                                  },
                                }),
                              }}
                            />
                            {errorMessage.ToInmateID && (
                              <div className="text-danger">
                                {errorMessage.ToInmateID}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row mb-3">
                          <label className="form-label col-form-label col-md-4 font-size-14">
                            {currentLang?.Mycontacts?.Transfer_Amount}($)
                          </label>
                          <div className="col-md-8">
                            <input
                              type="text"
                              name="TransferAmount"
                              className={`form-control ${submitted && !InmateDetail.TransferAmount && "border-danger"
                                }`}
                              value={InmateDetail.TransferAmount !== 0 && InmateDetail.TransferAmount !== "" ?
                                ((InmateDetail.TransferAmount.replace(/,/g, ""))
                                  ? (InmateDetail.TransferAmount.replace(/,/g, "")) : "") : ""}
                              onChange={handleChange1}
                              onBlur={handleBlur}
                              placeholder="Enter Transfer Amount"
                            />
                            {errorMessage.TransferAmount && (
                              <div className="text-danger">{errorMessage.TransferAmount}</div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={FundTransferCancelClick}
                        >
                          {currentLang?.buttons?.Cancel}
                        </button>
                        <button type="submit" className="btn btn-success">
                          {currentLang?.buttons?.Transfer}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loader}
      <ConfirmationModal
        show={isPaymentMsg}
        onHide={handlePaymentMsg}
        onConfirm={handlePaymentMsg}
        title={currentLang?.Message}
        message={paymentMsg}
        showCancelButton={false}
        onconfirmname={currentLang?.buttons?.OK}
      />
    </>
  );

}
export default React.memo(MyContacts);
